import React, { useEffect, useState } from "react";
import { Card, Button, Spinner, Row, Col } from "react-bootstrap";
import Axios from "../axios/axios";

const UserPending = () => {
  const [pendingUsers, setPendingUsers] = useState([]);
  const [loadingUserId, setLoadingUserId] = useState(null); // track loading for specific user
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    fetchPendingUsers();
  }, []);

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []); // Empty dependency → runs only once on mount

  const fetchPendingUsers = async () => {
    try {
      const { data } = await Axios.get("/api/user/users-with-pending");
      setPendingUsers(data);
      console.log(data);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const handleApproval = async (userId, action) => {
    setLoadingUserId(userId);
    try {
      console.log(action, "action");
      await Axios.put(`/api/user/${userId}/approval`, { action });
      fetchPendingUsers(); // refresh after approval/rejection
    } catch (error) {
      console.error("Approval error:", error);
    } finally {
      setLoadingUserId(null);
    }
  };

  const fieldLabels = {
    name: "Name",
    email: "Email",
    address1: "Place",
    address2: "Area",
    address3: "Pin",
    address4: "Post",
    phone: "Phone",
    phone1: "Alt Phone",
    photo: "Photo",
    id1Name: "Doc Type",
    id1: "Photo - Frontside",
    id1Sec: "Photo Backside Section",
    id2name: "Doc Type",
    id2: "Photo - Frondside",
    id2Sec: "Photo  Backside Section",
  };

  const filteredUsers = pendingUsers.filter((user) => {
    const term = searchTerm.toLowerCase();
    return (
      user.name?.toLowerCase().includes(term) ||
      user.email?.toLowerCase().includes(term) ||
      user.phone?.toLowerCase().includes(term) ||
      user.phone1?.toLowerCase().includes(term)
    );
  });

return (
  <div className="container mt-4" style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
    {/* 🔹 Static header */}
   <div
  className="d-flex justify-content-between align-items-center mb-3"
  style={{
    position: "sticky",
    top: 0,
    background: "#fff",
    zIndex: 10,
    padding: "10px 0",
  }}
>
  <h3>Pending User Approvals</h3>
  <input
    type="text"
    className="form-control"
    placeholder="Search by name or email"
    style={{ maxWidth: "250px" }}
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
  />
</div>


    {/* 🔹 Scrollable list */}
    <div style={{ flex: 1, overflowY: "auto" }}>
      {pendingUsers.length === 0 ? (
        <p>No pending updates.</p>
      ) : (
        filteredUsers.map((user) => (
          <Card key={user._id} className="mb-3 shadow-sm">
            {/* Action buttons aligned top-right */}
            <div className="d-flex justify-content-end gap-2 mt-3 me-3">
              <Button
                variant="success"
                disabled={loadingUserId === user._id}
                onClick={() => handleApproval(user._id, "approve")}
              >
                {loadingUserId === user._id ? (
                  <Spinner size="sm" animation="border" />
                ) : (
                  "Approve"
                )}
              </Button>
              <Button
                variant="danger"
                disabled={loadingUserId === user._id}
                onClick={() => handleApproval(user._id, "reject")}
              >
                Reject
              </Button>
            </div>

            <Card.Header>
              <h5 className="mb-0">{user.name}</h5>
              <small className="text-muted">{user.email}</small>
            </Card.Header>

            <Card.Body>
              {user.pendingUpdates && (
                <div>
                  <strong>Pending Fields:</strong>
                  <Row className="mt-2">
                    {Object.entries(user.pendingUpdates).map(([key, value]) => {
                      const label = fieldLabels[key] || key;
                      return (
                        <Col md={6} key={key} className="mb-3">
                          <strong>{label}:</strong>{" "}
                          {typeof value === "string" &&
                          value.startsWith("http") &&
                          (value.endsWith(".png") ||
                            value.endsWith(".jpg") ||
                            value.endsWith(".jpeg")) ? (
                            <>
                              <div>
                                <img
                                  src={value}
                                  alt={label}
                                  style={{
                                    width: "80px",
                                    height: "80px",
                                    objectFit: "cover",
                                    borderRadius: "8px",
                                  }}
                                  className="me-2 mb-1"
                                />
                              </div>
                              <a
                                href={value}
                                target="_blank"
                                rel="noopener noreferrer"
                                download
                              >
                                Download {label}
                              </a>
                            </>
                          ) : (
                            String(value)
                          )}
                        </Col>
                      );
                    })}
                  </Row>
                </div>
              )}
            </Card.Body>
          </Card>
        ))
      )}
    </div>
  </div>
);


};

export default UserPending;
